import React from "react";
import SimpleModalContent, {SimpleModalType} from "./SimpleModalContent";

interface ModalConfirmType extends SimpleModalType {
	text: string;
	isErrorVariant?: boolean;
	options?: {
		confirmText?: string;
		cancelText?: string;
	};
}

export default function ModalConfirmContent(props: ModalConfirmType) {
	return <SimpleModalContent {...props}>{props.text}</SimpleModalContent>;
}
